import React from 'react';
import PropTypes from 'prop-types';
import { Alert, Icon } from '@storable/canaveral-components';
import DescendantPagesUrlList from '../DescendantPagesUrlList';
import styles from './styles.scss';

const propTypes = {
  message: PropTypes.string.isRequired,
  urls: PropTypes.arrayOf(PropTypes.string).isRequired,
};
const defaultProps = {};

const PageListDescendantPagesBody = ({ message, urls }) => {
  const parentPageMessage = `This page is being used as a Parent Page for ${urls.length} custom URLs and may require redirects for the following:`;

  return (
    <React.Fragment>
      <Alert context="warning">
        <Icon id="warning-triangle" className={styles.warningIcon} />
        <div className={styles.warningText}>
          By updating the parent page and/or slug, you will impact the URLs of child pages. In order
          to prevent your old URLs from resulting in 404 errors (ie. “Page not found”), you’ll need
          to redirect your old URLs to your new URLs.
        </div>
      </Alert>
      <div className={styles.message}>{parentPageMessage}</div>
      <div className={styles.urlList}>
        <DescendantPagesUrlList
          urls={urls}
        />
      </div>
      <div className={styles.bottomMessage}>{message}</div>
    </React.Fragment>
  );
};

PageListDescendantPagesBody.propTypes = propTypes;
PageListDescendantPagesBody.defaultProps = defaultProps;

export default PageListDescendantPagesBody;
